<template>
	<div class="fo-wrap-content">
		<h4>bwHealthApp</h4>
		<div class="fo-wrap-links">
			<a href="https://www.digital-bw.de/-/zpm" target="_blank">Digital BW</a>
			<span>|</span>
			<a href="https://www.telemedbw.de/projekte/bwhealthapp" target="_blank">Telemedizin BW</a>
			<span>|</span>
			<a href="https://link.springer.com/chapter/10.1007%2F978-3-658-29133-4_7" target="_blank">Veröffentlichung</a>
			<span>|</span>
			<a href="https://artemis.reutlingen-university.de/" target="_blank">ARTEMIS</a>
			<div class="fo-divider"></div>
			<router-link v-if="$route.name != 'Impressum'" to="impressum">Impressum</router-link>
			<span v-if="$route.name == 'Home'">|</span>
			<router-link v-if="$route.name != 'AppPrivacy'" to="datenschutz-app">Datenschutz</router-link>
		</div>
	</div>
</template>

<script>
/**
 * @group Layout
 * Dynamic footer generator for all components
 */
export default {
	name: 'Footer',
	methods: {
		toImpressum() {
			this.$router.push({
				name: 'Impressum',
			});
		},
	},
};
</script>

<style scoped>
.fo-wrap-content {
	width: 90%;
	height: -webkit-fit-content;
	height: -moz-fit-content;
	height: fit-content;
	margin: 60px auto 0px auto;
	padding: 10px;
	text-align: center;
	background-color: var(--main-color-3);
	border-top: 2px solid var(--main-color-border-dark);
}

.fo-wrap-content h4 {
	font-size: 30px;
	margin: 10px auto;
	color: var(--main-color-text-light);
}

.fo-wrap-links {
	font-size: 20px;
	color: var(--main-color-0);
}

.fo-wrap-links p {
	width: -webkit-fit-content;
	width: -moz-fit-content;
	width: fit-content;
	margin: 0px;
	padding: 0px;
	display: inline-block;
}

.fo-footer-element {
	font-size: 20px;
	color: var(--main-color-1);
	text-decoration: none;
	padding: 2px 5px;
}

.fo-footer-element:hover {
	text-decoration: underline;
}

.fo-impressum {
	margin: 5px auto;
	padding: 5px 10px;
	font-size: 17px;
}

.fo-impressum:hover {
	background-color: var(--main-color-highlight);
}

a {
	margin: 5px 30px 0px 30px;
	text-decoration: none;
	color: var(--main-color-text-light);
	font-size: 20px;
}

a:hover {
	text-decoration: underline;
	color: var(--main-color-text-light);
}

.fo-divider {
	height: 10px;
}

@media (pointer: none), (pointer: coarse) {
	a {
		display: block;
		margin: 5px;
	}
	span {
		display: none;
	}
	.fo-divider {
		height: 0px;
	}
}
</style>
